import React from 'react';
import s from './styles.module.css'

const Empty = () => {
    return (
        <div className={s.empty}>
            Данных нет
        </div>
    );
};

export default Empty;
